module.exports = __webpack_public_path__ + "static/img/img-advncd.559aacac.jpg";